import React from "react";
import { Box, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

import styles from "./HeroBanner.module.scss";

const HeroBanner = ({
  slide: { title, description, redirectUrl, altText, imageUrl } = {},
  index,
  currentSlide,
  isAnimating,
  language,
}) => {

  return (
    <Box
      className={`${styles.slide} ${
        currentSlide === index ? styles.active : ""
      }`}
    >
      <Box className={styles.sliderContent}>
        {(title || description) && (
          <Box
            className={`${styles.leftContent} ${
              !isAnimating ? styles.active : ""
            }`}
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            {title && (
              <Typography variant="h1" className={styles.title}>
                {title?.[language]}
              </Typography>
            )}
            {description && (
              <Typography variant="body1" className={styles.description}>
                {description?.[language]}
              </Typography>
            )}
          </Box>
        )}
        <Box
          className={`${styles.rightContent} ${
            !isAnimating ? styles.active : ""
          }`}
        >
          {imageUrl && (
            <LazyLoadImage
              placeholderSrc="blur"
              src={imageUrl}
              alt={altText ? altText : ""}
              className={`${styles.wisdomImage} ${
                !isAnimating ? styles.active : ""
              }`}
              // onClick={() => {
              //   if (redirectUrl) {
              //     if (redirectUrl.startsWith("https")) {
              //       window.location.href = redirectUrl;
              //     } else {
              //       navigator(redirectUrl);
              //     }
              //   }
              // }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default HeroBanner;
